












































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import FundamentalLetter from "@/views/OWcom/ProFundamental/FundamentalLetter.vue";
import FundamentalCoverPage1 from "@/views/OWcom/ProFundamental/FundamentalCoverPage1.vue";
import FundamentalCoverPage2 from "@/views/OWcom/ProFundamental/FundamentalCoverPage2.vue";
import Summary1 from "@/views/OWcom/ProFundamental/Summary1.vue";
import Summary2 from "@/views/OWcom/ProFundamental/Summary2.vue";
import Summary3 from "@/views/OWcom/ProFundamental/Summary3.vue";
import Video from "@/components/Video.vue";
import Pdf from "@/components/Pdf.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconBoxArrowRight,
    FundamentalLetter,
    FundamentalCoverPage1,
    FundamentalCoverPage2,
    Summary1,
    Summary2,
    Summary3,
    Pdf,
    Video,
    NextPrevBtn,
    Footer
  }
})
export default class ProFundamental extends Vue {
  protected pdfPro = [
    {
      PdfLink: "/pdf_OWcom/betterWritePro.pdf",
      PdfDownload: "Fiche conseil rédaction",
      TxtPdf: "Fiche conseil rédaction"
    }
  ];
  protected videoTipsPro = [
    {
      videoSrc: "https://www.youtube.com/embed/B5LUC22dmdg",
      videoTitle: "Conseils pour améliorer vos compétences rédactionnelles",
      videoRoot: "Chaîne :  Lucie Rondelet"
    },
    {
      videoSrc: "https://www.youtube.com/embed/vFWoWZFDKB8",
      videoTitle: "Mad mapping : les 3 types de cartes mentales",
      videoRoot: "Chaîne :   Cyril Maitre"
    }
  ];
  protected nxtprevProFundamental = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail3.png",
    PrevLink: "",
    NextLink: "/Ecrit_Pro/Strategie"
  };
}
